import { render } from "./NavigationItem.vue?vue&type=template&id=48318881&scoped=true&ts=true"
import script from "./NavigationItem.vue?vue&type=script&lang=ts"
export * from "./NavigationItem.vue?vue&type=script&lang=ts"

import "./NavigationItem.vue?vue&type=style&index=0&id=48318881&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48318881"]])

export default __exports__